import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.map.js";
export default {
  props: {
    themeColor: {
      type: String,
      default: ''
    },
    styleObj: {
      type: Object,
      default() {
        return {};
      }
    }
  },
  data() {
    return {
      searchCheckedList: []
    };
  },
  mounted() {
    this.$nextTick(() => {
      var _this$styleObj$search;
      // 搜索条件
      console.log(this.styleObj, '----mobilePreview');
      this.searchCheckedList = (_this$styleObj$search = this.styleObj.searchTerms) === null || _this$styleObj$search === void 0 ? void 0 : _this$styleObj$search.map(item => {
        if (item.termDisplay) {
          return item.termValue;
        }
      });
    });
  },
  methods: {}
};